import connect from "assets/images/how/first.png";
import buyEth from "assets/images/how/second.png";
import wallet from "assets/images/how/third.png";

export const roadmap = [
  {
    date: "Q1 2022",
    img: connect,
    desc: ["Doge NFT Genesis release for early access adopters"],
    ok: true,
  },
  {
    date: "Q2 2022 I",
    img: buyEth,
    desc: [
      "Events, educational experiences, and podcast launch",
      "Official Doge NFT release (public sale)",
    ],
    ok: false,
  },
  {
    date: "Q2 2022 II",
    img: wallet,
    desc: [
      "Kennel club rewards launch (holders receive secondary market royalty percentage) ",
    ],
    ok: false,
  },
  {
    date: "Q2 2022 III",
    img: buyEth,
    desc: [
      "Content creator platform launch (NFT launchpad) ",
      "Membership card with exclusive benefits and discounts on future products",
    ],
    ok: false,
  },
  {
    date: "Q3 2022",
    img: wallet,
    desc: ["Metaverse land acquisitions"],
    ok: false,
  },
  {
    date: "Q4 2022",
    img: wallet,
    desc: ["Physical meetups and events (Southeast Asia, South America)"],
    ok: false,
  },
];
